import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";
import dayjs from "dayjs";
class MessageA15 extends Component {

    render() {
        return (
            <div className="s360-message-cotainer-received">
                <div className="s360-message-box-custom-a15-received" style={this.messageBoxStyle()}>
                    {this.props.entry.text || ''}
                </div>
                {this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("h:mm a")}</div>}
            </div>
        )
    }

    messageBoxStyle = () => {
        return { background: s360ConfigService.config.designDetails.recieverMessageColor, fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont, fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize, color: s360ConfigService.config.designDetails.recieverMessageFontColor }
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
    }

    messageTimeStyle = () => {
        return { fontFamily: s360ConfigService.config.designDetails.messageFont, fontSize: s360ConfigService.config.designDetails.messageTimeFontSize, color: s360ConfigService.config.designDetails.messageFontColor }
    }

}

export default MessageA15;